function getTypename(interfaceType: string[], defaultType: string): string {
  if (interfaceType && interfaceType[0] === defaultType) {
    return interfaceType[1];
  }
  return defaultType;
}

export class GlobalID<T extends number | string> {
  model: string;
  id: T;

  constructor({ model, id }) {
    this.model = model;
    this.id = id;
  }

  static decode<T extends number | string>(
    gid: string,
    options: { interfaceType: string[] } = { interfaceType: null }
  ) {
    let [_id, defaultType, ..._rest] = atob(gid).split('/').reverse();
    const model = getTypename(options.interfaceType, defaultType);
    let id: any;
    // If the id is a number
    if (/^\d+$/.test(_id)) {
      id = parseInt(_id, 10);
    } else {
      id = _id;
    }
    return new GlobalID<T>({ model, id });
  }

  toString() {
    const appName = 'fenix';
    return btoa(`gid://${appName}/${this.model}/${this.id}`);
  }

  toApolloCacheKey() {
    return `${this.model}:${this.id}`;
  }
}
